import { offlineContext } from './context';
import { listLibraryKeys, putLibraryItem, readLibraryItem, removeLibraryItem, type LibraryContext } from '@/native-shell/library';
import { projectDownload } from '@/native-shell/download';

export type DownloadKind = 'map' | 'journey' | 'window' | 'outing';
export async function saveDownload(key: string, kind: DownloadKind, title: string, payload: unknown, savedAt: string, expected?: LibraryContext): Promise<void> {
  const context = expected ?? await offlineContext();
  const raw = JSON.stringify({ version: 1, key, kind, title, savedAt, payload });
  if (!projectDownload(raw)) throw new Error('This download is incomplete or too large. Your previous copy has been kept.');
  const keys = await listLibraryKeys(context);
  if (kind === 'journey' && !keys.includes(key) && keys.filter(value => value.startsWith('journey:')).length >= 8) {
    throw new Error('Eight journeys are saved. Remove an old journey before saving another.');
  }
  await putLibraryItem(key, raw, context);
  window.dispatchEvent(new Event('peakwave-offline-downloads'));
}

export async function readDownload(key: string): Promise<unknown | null> {
  const raw = await readLibraryItem(key, await offlineContext());
  if (!raw) return null;
  if (!projectDownload(raw)) throw new Error('This download is damaged. Remove it and save a fresh copy.');
  return (JSON.parse(raw) as { payload: unknown }).payload;
}

export async function downloadKeys(kind: DownloadKind): Promise<string[]> {
  return (await listLibraryKeys(await offlineContext())).filter(key => key.startsWith(kind + ':'));
}

export async function removeDownload(key: string): Promise<void> {
  await removeLibraryItem(key, await offlineContext());
  window.dispatchEvent(new Event('peakwave-offline-downloads'));
}
